import React from 'react';
import PropTypes from 'prop-types';
import HeaderIconTooltip from './HeaderIconTooltip';
import { EditTabs } from '../Icons/Icons';

export default {
  title: 'Components/HeaderIconTooltip',
  component: HeaderIconTooltip,
  parameters: {
    layout: 'centered',
  },
  tags: ['autodocs'],
  argTypes: {
    heading: {
      control: { type: 'text' },
      description: 'The heading text to be displayed.',
      table: {
        type: { summary: 'string' },
      },
    },
    spanTextStart: {
      control: { type: 'text' },
      description: 'The starting part of the span text in Tooltip.',
      table: {
        type: { summary: 'string' },
      },
    },
    linkUrl: {
      control: { type: 'text' },
      description: 'The URL for the link in the tooltip.',
      table: {
        type: { summary: 'string' },
      },
    },
    linkText: {
      control: { type: 'text' },
      description: 'The text for the link in the tooltip.',
      table: {
        type: { summary: 'string' },
      },
    },
    spanTextEnd: {
      control: { type: 'text' },
      description: 'The ending part of the span text  in Tooltip.',
      table: {
        type: { summary: 'string' },
      },
    },
    place: {
      control: { type: 'select' },
      options: ['top', 'right', 'bottom', 'left'],
      description: 'The position of the tooltip:top, right, bottom, left.',
      table: {
        type: { summary: 'string' },
      },
    },
    iconName: {
      control: { type: 'text' },
      description: 'The name of the icon to be used.',
      table: {
        type: { summary: 'string' },
      },
    },
    icon: {
      control: { type: 'node' },
      description: 'The icon with tooltip text.',
    },
  },
  divTextStart: {
    control: { type: 'text' },
    description: 'The starting part of the span text in Tooltip.',
    table: {
      type: { summary: 'string' },
    },
  },
  divTextEnd: {
    control: { type: 'text' },
    description: 'The starting part of the span text in Tooltip.',
    table: {
      type: { summary: 'string' },
    },
  },
};

const HeaderIconTooltipTemplate = ({
  heading = 'Custom Fields', spanTextStart = 'Vamos Managers can add additional fields in the', linkUrl = '/admin/custom_fields', linkText = 'Custom Fields page', spanTextEnd = 'to capture data specific to your organization.', place = 'right', iconName = 'icon_circle', icon = null, divTextStart = '', divTextEnd = '',
}) => (
  <HeaderIconTooltip
    heading={heading}
    spanTextStart={spanTextStart}
    linkUrl={linkUrl}
    linkText={linkText}
    spanTextEnd={spanTextEnd}
    place={place}
    iconName={iconName}
    icon={icon}
    divTextStart={divTextStart}
    divTextEnd={divTextEnd}
  />
);

HeaderIconTooltipTemplate.propTypes = {
  heading: PropTypes.string,
  spanTextStart: PropTypes.string,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
  spanTextEnd: PropTypes.string,
  place: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  iconName: PropTypes.string,
  icon: PropTypes.node,
  divTextStart: PropTypes.string,
  divTextEnd: PropTypes.string,
};

const Template = HeaderIconTooltipTemplate.bind({});

export const CustomFieldsTooltip = Template.bind({});
CustomFieldsTooltip.args = {
  heading: 'Custom Fields',
  spanTextStart: 'Vamos Managers can add additional fields in the',
  linkUrl: '/admin/custom_fields',
  linkText: 'Custom Fields page',
  spanTextEnd: 'to capture data specific to your organization.',
  place: 'right',
  iconName: 'icon_circle',
};

export const DistributedItemsTooltip = Template.bind({});
DistributedItemsTooltip.args = {
  heading: 'Distributed Items',
  spanTextStart: 'Vamos Managers can configure your organization’s list of items in the',
  linkUrl: '/',
  linkText: 'Items for Distribution page.',
  spanTextEnd: '',
  place: 'top',
  iconName: 'icon_circle',
};

export const IconWithTooltip = Template.bind({});
IconWithTooltip.args = {
  divTextStart: 'You can edit the order of the tabs by',
  divTextEnd: 'dragging and dropping.',
  place: 'bottom',
  icon: <EditTabs />,
};
